module.exports = __webpack_public_path__ + "img/converifai-logo-white.770fa4ed.svg";